export default "__VITE_ASSET__6418c9f3__"